import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  num_pages: Yup.number() // Use Yup.number() for numeric values
    .min(5, "Minimum page length is 5")
    .max(30, "Maximum page length is 30")
    .required("Page length is required"),
  language: Yup.string().required("Language is required"),
});

export default validationSchema;
